export const WordpressApi = {
  url: "https://partner.janda.it/wordpress/wp-json/wp/v2",
  getPosts: async () => {
    return WordpressApi.requestJSON("/posts/", "GET");
  },
  getPages: async () => {
    return WordpressApi.requestJSON("/pages/", "GET");
  },
  getCategories: async () => {
    return WordpressApi.requestJSON("/categories/", "GET");
  },
  getVideos: async () => {
    return WordpressApi.requestJSON("/video/", "GET");
  },
  getPhotosFromActions: async () => {
    return WordpressApi.requestJSON("/fotky_z_akci/", "GET");
  },
  getReferences: async () => {
    return WordpressApi.requestJSON("/reference/", "GET");
  },
  getWhatWeDo: async () => {
    return WordpressApi.requestJSON("/co_umime/", "GET");
  },
  getSocials: async () => {
    return WordpressApi.requestJSON("/socialni_site/", "GET");
  },
  getMaterials: async () => {
    return WordpressApi.requestJSON("/materialy/", "GET");
  },
  getFilesToDownload: async () => {
    return WordpressApi.requestJSON("/podklady_ke_stazeni/", "GET");
  },
  request: async (endpoint, method = "GET", options = {}, token = null) => {
    const headers = {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    if (method !== "GET" && !headers["Content-Type"] && options.body) {
      headers["Content-Type"] = "application/json";
      headers["Accepts"] = "application/json";
    }

    const requestOptions = {
      method,
      headers,
    };

    if (options.body && method !== "GET" && method !== "HEAD") {
      requestOptions.body = JSON.stringify(options.body);
    }

    try {
      const response = await fetch(
        `${WordpressApi.url}${endpoint}`,
        requestOptions
      );

      return response;
    } catch (error) {
      console.error(`Chyba při požadavku na ${endpoint}:`, error);
      throw error;
    }
  },
  requestJSON: async (endpoint, method = "GET", options = {}, token = null) => {
    const response = await WordpressApi.request(
      endpoint,
      method,
      options,
      token
    );
    return response.json();
  },
};
